<div class="modal-overlay" *ngIf="isOpen" (click)="close()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <button class="modal-close" (click)="close()">×</button>
      <ng-content></ng-content>
    </div>
  </div>
  